import React from "react";
import "./bookingModal.css";

const formatTimeLabel = (time) => {
  if (!time) return "";
  const [hours, minutes] = time.split(":");
  return `${hours}:${minutes}`;
};

const BookingModal = ({
  visible,
  onCancel,
  onNext,
  coachData,
  slotData,
  selectedDate,
  topicData,
}) => {
  if (!visible || !coachData || !slotData) return null;

  const startTime = formatTimeLabel(slotData.startTime);
  const endTime = formatTimeLabel(slotData.endTime);

  return (
    <div
      className="booking-modal-overlay"
      onClick={onCancel}
      role="presentation"
    >
      <div
        className="booking-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="booking-modal-title"
      >
        <button
          type="button"
          className="booking-modal-close"
          aria-label="Close modal"
          onClick={onCancel}
        >
          <span className="material-symbols-outlined">close</span>
        </button>

        <div className="booking-modal-content">
          <div className="booking-avatar-wrapper">
            <img
              src={coachData.picture || "/default-avatar.png"}
              alt={coachData.name}
              className="booking-avatar"
            />
          </div>

          <h2 id="booking-modal-title" className="booking-coach-name">
            {coachData.name}
          </h2>

          <p className="booking-context">You are booking a session for:</p>

          <h3 className="booking-topic">{topicData}</h3>

          <div className="booking-time-card">
            <div className="booking-time">
              {startTime} - {endTime}
            </div>
            <div className="booking-date">{selectedDate}</div>
          </div>

          <div className="booking-actions">
            <button
              type="button"
              className="booking-btn booking-btn-cancel"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="booking-btn booking-btn-next"
              onClick={onNext}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
